/*
This file is located in the main branch
Last time the file was updated (UTC): [27.01.2024 4:51:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import UploadResponse from 'models/api/uploadResponse';

const uploadFile = <T = UploadResponse>(
    axios: AxiosInstance,
    controller: string,
    file: File,
    onUploadProgress?: (e: ProgressEvent) => void,
    params: any = undefined,
    action = 'upload'
) => {
    const formData = new FormData();
    formData.append('data', file);

    return axios.post<T>(controller + '/' + action, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params,
        onUploadProgress,
    });
};

export default uploadFile;
